(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mstard-product-card"] && !Shopify.designMode) return;
  try {
    (function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-atc');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.variantId;
    if (!id) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: parseInt(id, 10),
        quantity: 1,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(state) {
      btn.disabled = false;
      btn.innerHTML = 'Added ✓';
      setTimeout(function() { btn.innerHTML = 'Add to bag <span aria-hidden="true">→</span>'; }, 1800);

      // Re-render the cart drawer via Shopify Section Rendering API
      if (state.sections && state.sections['cart-drawer']) {
        var temp = document.createElement('div');
        temp.innerHTML = state.sections['cart-drawer'];
        var newDrawer = temp.querySelector('cart-drawer');
        var existingDrawer = document.querySelector('cart-drawer');
        if (existingDrawer && newDrawer) {
          existingDrawer.innerHTML = newDrawer.innerHTML;
          // Sync the empty-state flag on the <cart-drawer> element itself.
          // It was set at page load; replacing innerHTML alone leaves it, so
          // `.is-empty .cart__contents { display:none }` hides the first item.
          existingDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
          // Re-run Dawn's cart quantity JS on new elements
          if (window.QuantityInput) {
            existingDrawer.querySelectorAll('quantity-input').forEach(function(el) {
              new QuantityInput(el);
            });
          }
        }
      }

      // Update header cart count bubble
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var count = cart.item_count || 0;
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(el) {
            el.textContent = count;
          });
          document.querySelectorAll('.cart-count-bubble').forEach(function(el) {
            el.classList.toggle('hidden', count === 0);
          });
        });

      // Open Dawn's cart drawer
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
        cartDrawerEl.open();
      }
    })
    .catch(function() {
      btn.disabled = false;
      btn.innerHTML = 'Add to bag <span aria-hidden="true">→</span>';
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
